module.exports = __webpack_public_path__ + "prestashop.920a913523a8c16a4a79547e1a31fa1f.svg";